import { Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval, Subject, switchMap, takeUntil, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressService {
  readonly #progress = signal(0);

  readonly progress = this.#progress.asReadonly();

  readonly #startSubject = new Subject<void>();

  readonly #finalSubject = new Subject<void>();

  readonly #progressSubscription = this.#startSubject
    .pipe(
      switchMap(() =>
        interval(10).pipe(
          takeUntil(this.#finalSubject),
          tap({
            next: () => this.increment(),
            finalize: () => this.reset(),
          }),
        ),
      ),
      takeUntilDestroyed(),
    )
    .subscribe();

  start() {
    this.#startSubject.next();
  }

  increment() {
    this.#progress.update((p) => {
      // THe closer it is to 100 the slower it should go
      const diff = 100 - p;
      const speed = diff / 100;
      return p + speed * 5;
    });
  }

  complete() {
    this.#finalSubject.next();
  }

  reset() {
    this.#progress.set(0);
  }
}
